import { fetchWithHandling } from "../ApiUtils";
import { login } from "../login/UserLogin";

const URL = `${process.env.REACT_APP_API_URL}/api/registration`;
const target = "/register";

/**
 * GET request to fetch data for the dropdowns in the registration form.
 */
export const getDropdownData = async () => {
    return fetchWithHandling(URL, target, {
        method: "GET"
    })
}

export const getUserInfo = async () => {
    return fetchWithHandling(`${URL}/info`, target, {
        method: "GET"
    });
}

/**
 * POST request to send registration form data to the DB
 */
export const submitRegistrationData = async (data) => {
    const returnData = {
        success: null,
        message: null
    };

    const response = await fetch(URL, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
            // TODO: add authentication headers once Shibboleth is implemented
        },
        credentials: 'include',
        body: JSON.stringify(data)
    })

    const responseBody = await response.text();
    returnData.success = response.status === 201;

    returnData.message = responseBody;

    return returnData;
}